import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
    planToEditId: null
  },

  mutations: {
    CLEAN_PLAN_TO_EDIT (state) {
      state.planToEditId = null
    },
    PLAN_TO_EDIT_SELECTED (state, planToEditId) {
      state.planToEditId = planToEditId
    }
  },

  actions: {
    savePlan: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/conciliationPlan/savePlan', data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    getPlans: ({ commit }, url) => {
      return new Promise((resolve, reject) => {
        axios.get(url).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    getPlan: ({ commit }, idPlan) => {
      return new Promise((resolve, reject) => {
        axios.get('/conciliationPlan/find', { params: { idPlan: idPlan } }).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    setPlanToEdit: ({ commit }, planId) => {
      return new Promise((resolve, reject) => {
        commit('PLAN_TO_EDIT_SELECTED', planId)
        resolve()
      })
    },

    cleanPlanToEdit: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAN_PLAN_TO_EDIT')
        resolve()
      })
    },

    getFebraban: () => {
      return new Promise((resolve, reject) => {
        axios.get('/conciliationPlan/febraban').then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    getConciliationFields: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios.get('/conciliationPlan/conciliationFields').then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    removeConciliationPlan: ({ commit }, idPlan) => {
      return new Promise((resolve, reject) => {
        axios.delete('/conciliationPlan/removeConciliationPlan', {params: { idPlan: idPlan }}).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },

  getters: {
    planToEditId: state => state.planToEditId
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/conciliationPlan.js